// Degree Progress Map experiment utils used by Curriculum Management and DPM
import DegreesExperiments from 'bundles/epic/clients/Degrees';

/** A prefix to identify pre-production degree IDs. */
export const PRE_PROD_DEGREE_PREFIX = 'preprod___';

export const allExperimentDegreeSlugs = (): string[] => DegreesExperiments.get('showDegreeHomeForDegreeSlugs') ?? [];

/**
 * Get a list of all the DPM slugs visible to regular learners.
 * This ignores the user's preprod access epic
 */
export const prodDegreeSlugs = (): string[] => {
  return allExperimentDegreeSlugs().filter((slug) => !slug.startsWith(PRE_PROD_DEGREE_PREFIX));
};
